import React from 'react';
import { PlateLeaf } from 'platejs/react';

// @platejs/find-replace's FindReplacePlugin is decoration-ONLY: it marks every
// matching leaf with `search_highlight: true` but ships no render component, so
// the matches are invisible (the panel's scroll works because it computes ranges
// independently). This leaf component is what actually paints the match — Plate's
// pluginRenderLeaf wraps any leaf carrying the search_highlight key in it. The
// `slate-search_highlight` class is styled (soft yellow) in PlateEditor.module.scss.
// Decoration-only: never enters the serialized value or HTML export.
// Inline background (not only the .slate-search_highlight class) so a match is
// painted even if the global stylesheet rule doesn't reach a given surface.
export const SearchHighlightLeaf = React.memo(function SearchHighlightLeaf(props: any) {
    return (
        <PlateLeaf
            {...props}
            as="span"
            className="slate-search_highlight"
            style={{ backgroundColor: 'rgba(255, 212, 0, 0.5)', borderRadius: '2px' }}
        />
    );
});
